if (!Array.prototype.distinct) {
  // eslint-disable-next-line
  Array.prototype.distinct = function() {
    return this.filter((value, index, self) => self.indexOf(value) === index)
  }
}
